/* Good Deals TV — Kai and Crack Evolution monthly plan selector (1–3 TVs). */
(function () {
  'use strict';
  var paypalPlans = {
  "1": "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-06Y49303G4209605PNKWJ5OA",
  "2": "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-01797363DD969491RNLVTJVA",
  "3": "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-528296968K2408200NLVTL7I"
};
  function init() {
    document.querySelectorAll('[data-gd-tv-selector]').forEach(function (selector) {
      var card = selector.closest('.plan-card');
      if (!card) return;
      var price = card.querySelector('.plan-card__price');
      var subscribe = card.querySelector('[data-gd-tv-subscribe-link]');
      var message = selector.querySelector('.gd-tv-quantity__message');
      var choices = selector.querySelectorAll('[data-gd-tv-count]');
      var count = 1;
      function update() {
        if (price) price.textContent = '$' + (20 * count) + ' USD';
        choices.forEach(function (button) {
          var active = Number(button.getAttribute('data-gd-tv-count')) === count;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', String(active));
        });
        if (subscribe && paypalPlans[count]) {
          subscribe.href = paypalPlans[count];
          subscribe.removeAttribute('aria-disabled');
          subscribe.textContent = 'SUBSCRIBE';
          subscribe.hidden = false;
        }
        if (message) {
          message.textContent = '';
          message.hidden = true;
        }
      }
      choices.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = Number(button.getAttribute('data-gd-tv-count'));
          if (!paypalPlans[value]) return;
          count = value;
          update();
        });
      });
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();